import React from "react";

const DiscountOffer = () => {
  return;
  <div></div>;
};

export default DiscountOffer;
